import React from 'react';
import ReactTooltip from 'react-tooltip';
class SingleStat extends React.Component {
    constructor(props) {
        super(props);
    }
    getIconAndColor = (value, minRange, maxRange) => {
        const meanOfRanges = (minRange + maxRange) / 2;
        const offsetValue = meanOfRanges / 10;
        const minOffset = minRange - offsetValue,
            maxOffset = maxRange + offsetValue;
        if (value >= minRange && value <= maxRange) {
            return { className: "fa fa-check-circle", color: "#7ED321", title: this.props.i18next.t("lable.greatScore") }
        } else if (value >= minOffset && value <= maxOffset) {
            return { className: "fa fa-exclamation-circle", color: "#F5A623", title: this.props.i18next.t("lable.couldBeImproved") }
        } else {
            return { className: "fa fa-exclamation-triangle", color: "#D0021B", title: this.props.i18next.t("lable.majorLeak")}
        }
    }

    render() {
        const props = this.props;
        if(props.data.name === 'Win Rate Ev Allin Adjusted'){props.data.name = 'Winrate – All-In EV Adjusted'}
        let startRange = props.data && parseFloat(props.data.minRange) ? parseFloat(props.data.minRange) : 0,
            endRange = props.data && parseFloat(props.data.maxRange) ? parseFloat(props.data.maxRange) : 0,
            dataValue = props.data && parseFloat(props.data.value) ? parseFloat(props.data.value) : 0;
        const iconStyle = this.getIconAndColor(dataValue, startRange, endRange);
        console.log("icon style",iconStyle);
        let statsValueIndicator = null;
        switch (props.data.name.toUpperCase()) {
            case "WIN RATE":
            case "WINRATE – ALL-IN EV ADJUSTED":
                startRange = ((startRange / 20) * 100) / 2 + 50;
                endRange = ((endRange / 9999) * 100) / 2 + 50;
                if (dataValue >= 20) {
                    dataValue = 100;
                } else if (dataValue <= -20) {
                    dataValue = 0;
                } else {
                    dataValue = ((dataValue / 20) * 100) / 2 + 50;
                }
                break;
            case "CHIPS PER GAME":
            case "EV CHIPS PER GAME":
                startRange = ((startRange / 9999) * 100) / 2 + 50;
                endRange = ((endRange / 9999) * 100) / 2 + 50;
                dataValue = ((dataValue / 9999) * 100) / 2 + 50;
                break;

            // default:
                // if (props.data.maxPossibleValue !== props.data.minPossibleValue) {
                //     // if (props.data.name === "Win Rate") {
                //     //     console.log("-----------start---------------")
                //     //     console.log("startRange", startRange)
                //     //     console.log("endRange", endRange)
                //     //     console.log("dataValue", dataValue)
                //     //     console.log("props.data.maxPossibleValue", props.data.maxPossibleValue)
                //     //     console.log("props.data.minPossibleValue", props.data.minPossibleValue)
                //     //     console.log("(props.data.maxPossibleValue - props.data.minPossibleValue)", (props.data.maxPossibleValue - props.data.minPossibleValue))
                //     // }

                //     startRange = ((startRange / (props.data.maxPossibleValue - props.data.minPossibleValue)) * 100);
                //     endRange = ((endRange / (props.data.maxPossibleValue - props.data.minPossibleValue)) * 100);
                //     dataValue = ((dataValue / (props.data.maxPossibleValue - props.data.minPossibleValue)) * 100);
                //     // if (props.data.name === "Win Rate") {
                //     //     console.log("(startRange / (props.data.maxPossibleValue - props.data.minPossibleValue))", (startRange / (props.data.maxPossibleValue - props.data.minPossibleValue)))
                //     //     console.log("(startRange / (props.data.maxPossibleValue - props.data.minPossibleValue)) * 100", (startRange / (props.data.maxPossibleValue - props.data.minPossibleValue)) * 100)

                //     //     console.log("(endRange / (props.data.maxPossibleValue - props.data.minPossibleValue))", (endRange / (props.data.maxPossibleValue - props.data.minPossibleValue)))
                //     //     console.log("(endRange / (props.data.maxPossibleValue - props.data.minPossibleValue)) * 100", (endRange / (props.data.maxPossibleValue - props.data.minPossibleValue)) * 100)

                //     //     console.log("(dataValue / (props.data.maxPossibleValue - props.data.minPossibleValue))", (dataValue / (props.data.maxPossibleValue - props.data.minPossibleValue)))
                //     //     console.log("(dataValue / (props.data.maxPossibleValue - props.data.minPossibleValue)) * 100", (dataValue / (props.data.maxPossibleValue - props.data.minPossibleValue)) * 100)

                //     //     console.log("----------after----------------")
                //     //     console.log("startRange", startRange)
                //     //     console.log("endRange", endRange)
                //     //     console.log("dataValue", dataValue)
                //     //     console.log("----------end----------------")
                //     // }

                //     if (props.data.minPossibleValue < 0) {
                //         startRange = (startRange / 2) + 50;
                //         endRange = (endRange) + 50;
                //         dataValue = (dataValue / 2) + 50
                //     }
                // }
        }
        statsValueIndicator = <div className="ms_Stats_Value_Indicator">
            <div className="ms_greenOptmalBar" style={{ left: `${startRange}%`, right: `${100 - endRange}%` }} />
            <div className="ms_statsValuePointer" style={{ left: `${dataValue}%` }} />
        </div>

        return (
            <div data-e2e="myStats-statsCard-singleStats-container">
                <div className="ms_Stats_heading_field">
                    <div data-e2e="myStats-statsCard-singleStats-name"
                        className="ms_card_field_name"><b style={{ marginRight: "2.5px" }}>{props.data.name}</b>
                        {props.data.minRange !== props.data.maxRange
                            && <span className="ms_optimalRange" >{props.data.name.toUpperCase() === "WIN RATE" || props.data.name.toUpperCase() === "WINRATE – ALL-IN EV ADJUSTED" ? `(Optimal ${props.data.minRange}+)` : `(Optimal ${props.data.minRange}-${props.data.maxRange})`}</span>}
                    </div>
                    <div data-e2e="myStats-statsCard-singleStats-value"
                        className="ms_card_field_value">{props.data.value !== undefined && props.data.value !== null
                            ? <b style={{ marginRight: "2.5px" }}>{props.data.value}{props.data.name.indexOf("%") >= 0 ? "%" : ""}</b>
                            : <b style={{ marginRight: "2.5px" }}>N/A</b>}
                        {(props.data.minRange !== props.data.maxRange && props.data.value != undefined) &&
                            <span className="cursor-pointer" data-tip data-for={'tooltip' + props.data.name}>
                                <i className={iconStyle.className} style={{ color: iconStyle.color }} />
                                <style>{"\
                                .__react_component_tooltip.type-dark.place-top:after {\
                                    border-top-style: none;\
                                }\
                                "}
                                </style>
                                <ReactTooltip id={'tooltip' + props.data.name}
                                    place='top'
                                    effect='solid' className="ms_tooltip">
                                    <span>{iconStyle.title}</span>
                                </ReactTooltip>
                            </span>}
                        </div>
                </div>
                {statsValueIndicator}
            </div>
        )
    }
}

export default SingleStat;


/** WEBPACK FOOTER **
 ** ./src/components/MyStatistics/SingleStat.js
 **/